module.exports = __webpack_public_path__ + "img/1540698033.371da5a6.jpg";